/**
 * Convert a string to a URL-friendly slug
 * Handles English, Thai, and Lao characters
 */
/** ตัวอักษรที่ slugify อนุญาต — EN, TH, LO, ตัวเลข, ขีด */
export const SLUG_CHAR_CLASS = "a-z0-9\\u0E00-\\u0E7F\\u0E80-\\u0EFF";

export const SLUG_SAFE_PATTERN = new RegExp(
  `^[${SLUG_CHAR_CLASS}]+(?:-[${SLUG_CHAR_CLASS}]+)*$`,
);

export function isValidSlug(value: string): boolean {
  return SLUG_SAFE_PATTERN.test(value.toLowerCase().trim());
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\u0E00-\u0E7F\u0E80-\u0EFF-]+/g, "") // Remove special chars (keep EN/TH/LO)
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start
    .replace(/-+$/, ""); // Trim - from end
}
